var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Headline'),_c('div',{staticClass:"container-fluid step-loader"},[_c('div',{staticClass:"row"},[_c('Status',{attrs:{"img":"contract_error.svg"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }